import {SignInRequest, SignInResponse} from "@/types/userTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import {authConfig} from "./platformConfig";

export type TagTypes = "Users";

const authApi = createApi({
  reducerPath: "authApi",
  ...authConfig(),
  endpoints: (builder) => ({
    signIn: builder.mutation<SignInResponse, SignInRequest>({
      query: (config): FetchArgs => ({
        url: "/auth/signin",
        method: "POST",
        body: config,
      }),
      transformResponse: (response, meta) => {
        return {
          data: response as {
            status: string;
            formFields: Record<string, string>[];
            reason: string;
          },
          headers: meta?.response?.headers ?? new Headers(),
        };
      },
    }),
  }),
});

export const {useSignInMutation} = authApi;

export default authApi;
